import React from 'react';
import { useAuth } from 'auth/context/AuthContext';
import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import moment from 'moment/moment';
import { STANDARD_DATE } from 'utilities/dateHelper';
import { Roles } from '../../../../firebase/interfaces';
import { Card } from '../Card';

const ProviderSkip = ({ lastUpdated }: { lastUpdated?: string }) => {
  const { user } = useAuth();
  const isProvider = user?.role === Roles.PROVIDER;

  const { data: locale } = useGetPage({
    locale: 'en',
    pageId: pageIds.COMPLETE_MY_VISIT_SUMMARY_MODAL,
  });

  return (
    <Card
      title={locale?.summaryDetails}
      titleClassName="flex text-h4 text-btn-black font-semibold"
      showSeparator
      defaultExpanded
      subtitleClassName="!text-base font-medium max-desktop:mt-2.5"
      subtitle={moment(lastUpdated).format(`[Summary date:] ${STANDARD_DATE}`)}
    >
      <div className="w-full h-full text-center py-48 px-32">
        <div className="text-lg font-semibold mb-1">
          {isProvider
            ? 'You missed this appointment'
            : 'Provider was unavailable'}
        </div>
        <div className="font-medium text-center text-med-gray-3">
          {isProvider
            ? 'You missed this appointment. Due to Decode.me Privacy Policy the patient will receive a full refund $ for the appointment'
            : 'Unfortunately, your provider was unavailable for the appointment. The full amount will be refunded to your account. You can use the refunded credit to book a new appointment.'}
        </div>
      </div>
    </Card>
  );
};

export default ProviderSkip;
